export default "__VITE_ASSET__BKIAtvDf__"